<span class="badge badge-pill badge-danger" *ngIf="contato && contato.bloqueado"> <i class="fe-user"></i>Bloqueado</span>
<ng-container *ngIf="contato && !contato.bloqueado && nome()">
  <span class="badge badge-pill segmento" [ngClass]="classe()"><span class="ponto"></span>{{ nome() }}</span>
</ng-container>
